import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  firstName: '',
  lastName: '',
  userId: '',
  id: null, // User ID (used as GetUserId in localStorage)
  customerId: null,
  companyName: '',
  systemRole: '',
  systemroles: '', // Legacy field name used in some components
  clientStatus: null,
  projectStatus: null,
  dashboardConfig: null,
  teamRoles: null,
  theme: null,
  permissions: null,
  bulkUpload: 25, // Document bulk upload limit
  selectedcountries: null, // Selected countries for user
  flatFee: null,
  flatFeeCountryId: null,
  userstatus: null,
  portals: '',
  integrations: '',
  phoneNumbers: [],
  aliasName: '',
  features: '', // Comma-separated feature flags (e.g., 'reports')
};

export const AuthSlice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    updateAuth: (state, action) => {
      if (action.payload) {
        state.email = action.payload.emailId || '';
        state.firstName = action.payload.firstName || '';
        state.lastName = action.payload.lastName || '';
        state.userId = action.payload.userId || '';
        state.id =
          action.payload.user_Id ||
          action.payload.id ||
          action.payload.userId ||
          null;
        state.customerId =
          action.payload.customerId || action.payload.id || null;
        state.companyName = action.payload.companyName || '';
        state.systemRole = action.payload.systemroles || '';
        state.systemroles =
          action.payload.systemroles || action.payload.systemRole || '';
        state.clientStatus = action.payload.clientStatus || null;
        state.projectStatus =
          action.payload.project || action.payload.projectStatus || null;
        state.dashboardConfig = action.payload.dashboardConfig || null;
        state.teamRoles = action.payload.teamRoles || null;
        state.theme = action.payload.theme || null;
        state.permissions = action.payload.permissions || null;
        state.bulkUpload = action.payload.bulkUpload || 25;
        state.selectedcountries = action.payload.selectedcountries || null;
        state.flatFee = action.payload.flatFee || '';
        state.flatFeeCountryId = action.payload.flatFeeCountryId || '';
        state.userstatus = action.payload.userstatus || '';
        state.portals = action.payload.portals || '';
        state.integrations = action.payload.integrations || '';
        state.phoneNumbers = action.payload.phoneNumbers || [];
        state.aliasName = action.payload.aliasName || '';
        state.features = action.payload.features || '';
      } else {
        return initialState;
      }
    },
    clearAuth: () => initialState,
  },
});

export const { updateAuth, clearAuth } = AuthSlice.actions;

export default AuthSlice.reducer;
